import copyToClipboard from 'copy-to-clipboard';
import React, {useCallback} from 'react';

import {useSelector} from '../../../state/hooks';
import * as PanelBankSectionConfigTypes from '../../../state/views/panelBankSectionConfig/types';
import {nwToast} from '../../../state/workspaces/namedWorkspaceToast';
import {PanelCopyLinkMenuItem} from '../common/PanelCopyLinkMenuItem';
import {getSharePanelLink} from '../FullScreenPanel/fullScreenUtils';
import {usePanelContext} from '../PanelContextProvider';

/**
 * If we are trying to copy the link for a panel on a regular workspace, we need
 * to generate the full screen panel link to be copied.
 */
export const WorkspacePanelCopyLinkMenuItem = ({
  panelBankSectionConfigRef,
}: {
  panelBankSectionConfigRef: PanelBankSectionConfigTypes.Ref;
}) => {
  const {panel, trackPanelControls} = usePanelContext();
  const panelBankSectionName = useSelector(state => {
    return state.views.parts[panelBankSectionConfigRef.type][
      panelBankSectionConfigRef.id
    ]?.name;
  });

  const onSelect = useCallback(() => {
    const sharePanelPath = getSharePanelLink(panel, panelBankSectionName);
    copyToClipboard(`${window.location.origin}${sharePanelPath}`);
    nwToast('Copied to clipboard');

    trackPanelControls({action: 'Panel link copied'});
  }, [panel, panelBankSectionName, trackPanelControls]);

  return <PanelCopyLinkMenuItem onSelect={onSelect} />;
};
